"use client";

import { createContext, useContext } from "react";
import type { HubConnection } from "@microsoft/signalr";

export interface SignalRContextValue {
  connection: HubConnection | null;
  isConnected: boolean;
}

export const SignalRContext = createContext<SignalRContextValue>({
  connection: null,
  isConnected: false,
});

export function useSignalRConnection(): HubConnection | null {
  return useContext(SignalRContext).connection;
}

export function useSignalRConnectionState(): boolean {
  return useContext(SignalRContext).isConnected;
}
